"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _map = require("../../$map/map");

var _raceTo = _interopRequireDefault(require("./race-to"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const makeCanTakeAny = buffers => () => {
  return (0, _raceTo.default)(Boolean, false, (0, _map.map)(buffers, async buffer => (await buffer.canTake()) ? buffer : null));
};

var _default = makeCanTakeAny;
exports.default = _default;
module.exports = exports["default"];